module.exports = __webpack_public_path__ + "static/media/9.21267f2d.jpg";